import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=228ebea1"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports